import { DocumentTypeCodeEnum } from '@elearning-platform/api-types/enums';
import { DocumentArchiveAddFileResultInterface } from '@elearning-platform/api-types/interfaces';

import { api } from '../api';

export const downloadDocumentFromUserArchiveByReviewer: (documentId: number) => Promise<void> = (
  documentId: number
): Promise<void> => api.get(
  `/archive-administration/documents/${documentId}/download`, { responseType: 'blob' }
);

export const downloadFileFromUserArchiveByReviewer: (
  documentId: number, fileId: number
) => Promise<void> = (
  documentId: number, fileId: number
): Promise<void> => api.get(
  `/archive-administration/documents/${documentId}/files/${fileId}/download`, { responseType: 'blob' }
);

export const downloadFileFromUserArchiveByReviewerAsStream: (
  documentId: number, fileId: number
) => Promise<string> = (
  documentId: number, fileId: number
): Promise<string> => api.get(
  `/archive-administration/documents/${documentId}/files/${fileId}/download`,
  { customEnv: { notEncryptedResponse: true } }
);

export const uploadUserDocuments: (
  userId: string, documentTypeCode: DocumentTypeCodeEnum, files: File[]
) => Promise<DocumentArchiveAddFileResultInterface> = (
  userId: string, documentTypeCode: DocumentTypeCodeEnum, files: File[]
): Promise<DocumentArchiveAddFileResultInterface> => {
  const formData: FormData = new FormData();
  formData.append('documentTypeCode', documentTypeCode);
  files.forEach((file: File): void => formData.append('files', file));

  return api.post(
    `archive-administration/users/${userId}/documents`,
    formData,
    { customEnv: { notEncryptedRequest: true } },
  );
};

export const downloadDocumentArchiveFileForAdmin: (documentId: number) => Promise<void> = (
  documentId: number
): Promise<void> => api.get(
  `/archive-administration/documents/${documentId}/download`, { responseType: 'blob' }
);
